<template>
  <IconPlusRecycle
    v-if="buybackIconExperiment === 'withCircleIcon'"
    v-bind="$attrs"
  />
  <IconMoneyCircle
    v-else-if="buybackIconExperiment === 'withMoneyIcon'"
    v-bind="$attrs"
  />
  <IconSwap v-else v-bind="$attrs" />
</template>

<script setup lang="ts">
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { IconSwap } from '@ds/icons/IconSwap'

import IconMoneyCircle from '../IconMoneyCircle/IconMoneyCircle.vue'
import IconPlusRecycle from '../IconPlusRecycle/IconPlusRecycle.vue'

defineOptions({ inheritAttrs: false })

const experiments = useExperiments()
const buybackIconExperiment = experiments['experiment.buybackIcon']
</script>
